import PanelNotifications from "../../components/PanelNotifications";

export default function StudentNotifications() {
  return (
    <PanelNotifications
      apiPrefix="student"
      subtitle="Payment receipts for papers, mock exams, packs and courses."
    />
  );
}
